import React from 'react';

export default function SearchMagnifyIcon(props) {
  const { iconLeft = false } = props;
  return (
    <svg
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={18}
      height={18}
      {...props}
    >
      <title>icons/search</title>
      <defs>
        <path
          d="M12.4444444,1.42108547e-14 C19.3173213,1.42108547e-14 24.8888889,5.57156756 24.8888889,12.4444444 C24.8888889,15.5209152 23.7725248,18.3366452 21.9227949,20.508636 L31.444954,30.0307404 C31.8354783,30.4212647 31.8354783,31.0544297 31.444954,31.444954 C31.08447,31.805438 30.517239,31.8331675 30.1249478,31.5281426 L30.0307404,31.444954 L20.508636,21.9227949 C18.3366452,23.7725248 15.5209152,24.8888889 12.4444444,24.8888889 C5.57156756,24.8888889 0,19.3173213 0,12.4444444 C0,5.57156756 5.57156756,1.42108547e-14 12.4444444,1.42108547e-14 Z M12.4444444,2 C6.67613706,2 2,6.67613706 2,12.4444444 C2,18.2127518 6.67613706,22.8888889 12.4444444,22.8888889 C18.2127518,22.8888889 22.8888889,18.2127518 22.8888889,12.4444444 C22.8888889,6.67613706 18.2127518,2 12.4444444,2 Z"
          id="path-1"
        />
      </defs>
      <g
        id="5-Bookings"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Group">
          <rect
            id="Rectangle"
            fillRule="nonzero"
            x="0"
            y="0"
            width="32"
            height="32"
          />
          <g id="search" transform="translate(-0.000000, -0.000000)">
            <mask id="mask-2" fill="white">
              <use xlinkHref="#path-1" />
            </mask>
            <use id="color" fill="#898C9A" xlinkHref="#path-1" />
          </g>
        </g>
      </g>
    </svg>
  );
}
